// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"779":"4a7fdb30","937":"a4ac89f4"}[chunkId] + ".chunk.js";
};